function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/mergecellcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableWalker from '../tablewalker';
import { getTableCellsContainingSelection } from '../utils/selection';
import { isHeadingColumnCell } from '../utils/common';
import { removeEmptyRowsColumns } from '../utils/structure';
/**
 * The merge cell command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'mergeTableCellRight'`, `'mergeTableCellLeft'`,
 * `'mergeTableCellUp'` and `'mergeTableCellDown'` editor commands.
 *
 * To merge a table cell at the current selection with another cell, execute the command corresponding with the preferred direction.
 *
 * For example, to merge with a cell to the right:
 *
 *		editor.execute( 'mergeTableCellRight' );
 *
 * **Note**: If a table cell has a different [`rowspan`](https://www.w3.org/TR/html50/tabular-data.html#attr-tdth-rowspan)
 * (for `'mergeTableCellRight'` and `'mergeTableCellLeft'`) or [`colspan`](https://www.w3.org/TR/html50/tabular-data.html#attr-tdth-colspan)
 * (for `'mergeTableCellUp'` and `'mergeTableCellDown'`), the command will be disabled.
 *
 * @extends module:core/command~Command
 */

var MergeCellCommand = /*#__PURE__*/function (_Command) {
  _inherits(MergeCellCommand, _Command);

  var _super = _createSuper(MergeCellCommand);

  /**
   * Creates a new `MergeCellCommand` instance.
   *
   * @param {module:core/editor/editor~Editor} editor The editor on which this command will be used.
   * @param {Object} options
   * @param {String} options.direction Indicates which cell to merge with the currently selected one.
   * Possible values are: `'left'`, `'right'`, `'up'` and `'down'`.
   */
  function MergeCellCommand(editor, options) {
    var _this;

    _classCallCheck(this, MergeCellCommand);

    _this = _super.call(this, editor);
    /**
     * The direction that indicates which cell will be merged with the currently selected one.
     *
     * @readonly
     * @member {String} #direction
     */

    _this.direction = options.direction;
    /**
     * Whether the merge is horizontal (left/right) or vertical (up/down).
     *
     * @readonly
     * @member {Boolean} #isHorizontal
     */

    _this.isHorizontal = _this.direction == 'right' || _this.direction == 'left';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MergeCellCommand, [{
    key: "refresh",
    value: function refresh() {
      var cellToMerge = this._getMergeableCell();

      this.value = cellToMerge;
      this.isEnabled = !!cellToMerge;
    }
    /**
     * Executes the command.
     *
     * Depending on the command's {@link #direction} value, it will merge the cell that is to the `'left'`, `'right'`, `'up'` or `'down'`.
     *
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var model = this.editor.model;
      var doc = model.document;
      var tableCell = getTableCellsContainingSelection(doc.selection)[0];
      var cellToMerge = this.value;
      var direction = this.direction;
      model.change(function (writer) {
        var isMergeNext = direction == 'right' || direction == 'down'; // The merge mechanism is always the same so sort cells to be merged.

        var cellToExpand = isMergeNext ? tableCell : cellToMerge;
        var cellToRemove = isMergeNext ? cellToMerge : tableCell; // Cache the parent of cell to remove for later check.

        var removedTableCellRow = cellToRemove.parent;
        mergeTableCells(cellToRemove, cellToExpand, writer);
        var spanAttribute = _this2.isHorizontal ? 'colspan' : 'rowspan';
        var cellSpan = parseInt(tableCell.getAttribute(spanAttribute) || 1);
        var cellToMergeSpan = parseInt(cellToMerge.getAttribute(spanAttribute) || 1); // Update table cell span attribute and merge set selection on merged contents.

        writer.setAttribute(spanAttribute, cellSpan + cellToMergeSpan, cellToExpand);
        writer.setSelection(writer.createRangeIn(cellToExpand));

        var tableUtils = _this2.editor.plugins.get('TableUtils');

        var table = removedTableCellRow.findAncestor('table'); // Remove empty rows and columns after merging.

        removeEmptyRowsColumns(table, tableUtils);
      });
    }
    /**
     * Returns a cell that can be merged with the current cell depending on the command's direction.
     *
     * @returns {module:engine/model/element~Element|undefined}
     * @private
     */

  }, {
    key: "_getMergeableCell",
    value: function _getMergeableCell() {
      var model = this.editor.model;
      var doc = model.document;
      var tableCell = getTableCellsContainingSelection(doc.selection)[0];

      if (!tableCell) {
        return;
      }

      var tableUtils = this.editor.plugins.get('TableUtils'); // First get the cell on proper direction.

      var cellToMerge = this.isHorizontal ? getHorizontalCell(tableCell, this.direction, tableUtils) : getVerticalCell(tableCell, this.direction);

      if (!cellToMerge) {
        return;
      } // If found check if the span perpendicular to merge direction is equal on both cells.


      var spanAttribute = this.isHorizontal ? 'rowspan' : 'colspan';
      var span = parseInt(tableCell.getAttribute(spanAttribute) || 1);
      var cellToMergeSpan = parseInt(cellToMerge.getAttribute(spanAttribute) || 1);

      if (cellToMergeSpan === span) {
        return cellToMerge;
      }
    }
  }]);

  return MergeCellCommand;
}(Command); // Returns the cell that can be merged horizontally.
//
// @param {module:engine/model/element~Element} tableCell
// @param {String} direction
// @returns {module:engine/model/node~Node|null}


export { MergeCellCommand as default };

function getHorizontalCell(tableCell, direction, tableUtils) {
  var tableRow = tableCell.parent;
  var table = tableRow.parent;
  var horizontalCell = direction == 'right' ? tableCell.nextSibling : tableCell.previousSibling;
  var hasHeadingColumns = (table.getAttribute('headingColumns') || 0) > 0;

  if (!horizontalCell) {
    return;
  } // Sort cells:


  var cellOnLeft = direction == 'right' ? tableCell : horizontalCell;
  var cellOnRight = direction == 'right' ? horizontalCell : tableCell; // Get their column indexes:

  var _tableUtils$getCellLo = tableUtils.getCellLocation(cellOnLeft),
      leftCellColumn = _tableUtils$getCellLo.column;

  var _tableUtils$getCellLo2 = tableUtils.getCellLocation(cellOnRight),
      rightCellColumn = _tableUtils$getCellLo2.column;

  var leftCellSpan = parseInt(cellOnLeft.getAttribute('colspan') || 1);
  var isCellOnLeftInHeadingColumn = isHeadingColumnCell(tableUtils, cellOnLeft, table);
  var isCellOnRightInHeadingColumn = isHeadingColumnCell(tableUtils, cellOnRight, table); // We cannot merge heading columns cells with regular cells.

  if (hasHeadingColumns && isCellOnLeftInHeadingColumn != isCellOnRightInHeadingColumn) {
    return;
  } // The cell on the right must have index that is distant to the cell on the left by the left cell's width (colspan).


  var cellsAreTouching = leftCellColumn + leftCellSpan === rightCellColumn; // If the right cell's column index is different it means that there are rowspanned cells between them.

  return cellsAreTouching ? horizontalCell : undefined;
} // Returns the cell that can be merged vertically.
//
// @param {module:engine/model/element~Element} tableCell
// @param {String} direction
// @returns {module:engine/model/node~Node|null}


function getVerticalCell(tableCell, direction) {
  var tableRow = tableCell.parent;
  var table = tableRow.parent;
  var rowIndex = table.getChildIndex(tableRow); // Don't search for mergeable cell if direction points out of the table.

  if (direction == 'down' && rowIndex === table.childCount - 1 || direction == 'up' && rowIndex === 0) {
    return;
  }

  var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
  var headingRows = table.getAttribute('headingRows') || 0;
  var isMergeWithBodyCell = direction == 'down' && rowIndex + rowspan === headingRows;
  var isMergeWithHeadCell = direction == 'up' && rowIndex === headingRows; // Don't search for mergeable cell if direction points out of the current table section.

  if (headingRows && (isMergeWithBodyCell || isMergeWithHeadCell)) {
    return;
  }

  var currentCellRowSpan = parseInt(tableCell.getAttribute('rowspan') || 1);
  var rowOfCellToMerge = direction == 'down' ? rowIndex + currentCellRowSpan : rowIndex;

  var tableMap = _toConsumableArray(new TableWalker(table, {
    endRow: rowOfCellToMerge
  }));

  var currentCellData = tableMap.find(function (value) {
    return value.cell === tableCell;
  });
  var mergeColumn = currentCellData.column;
  var cellToMergeData = tableMap.find(function (_ref) {
    var row = _ref.row,
        cellHeight = _ref.cellHeight,
        column = _ref.column;

    if (column !== mergeColumn) {
      return false;
    }

    if (direction == 'down') {
      // If merging a cell below the mergeRow is already calculated.
      return row === rowOfCellToMerge;
    } else {
      // If merging a cell above calculate if it spans to mergeRow.
      return rowOfCellToMerge === row + cellHeight;
    }
  });
  return cellToMergeData && cellToMergeData.cell;
} // Merges two table cells. It will ensure that after merging cells with an empty paragraph, the resulting table cell will only have one
// paragraph. If one of the merged table cells is empty, the merged table cell will have the contents of the non-empty table cell.
// If both are empty, the merged table cell will have only one empty paragraph.
//
// @param {module:engine/model/element~Element} cellToRemove
// @param {module:engine/model/element~Element} cellToExpand
// @param {module:engine/model/writer~Writer} writer


function mergeTableCells(cellToRemove, cellToExpand, writer) {
  if (!isEmpty(cellToRemove)) {
    if (isEmpty(cellToExpand)) {
      writer.remove(writer.createRangeIn(cellToExpand));
    }

    writer.move(writer.createRangeIn(cellToRemove), writer.createPositionAt(cellToExpand, 'end'));
  } // Remove merged table cell.


  writer.remove(cellToRemove);
} // Checks if the passed table cell contains an empty paragraph.
//
// @param {module:engine/model/element~Element} tableCell
// @returns {Boolean}


function isEmpty(tableCell) {
  return tableCell.childCount == 1 && tableCell.getChild(0).is('element', 'paragraph') && tableCell.getChild(0).isEmpty;
}